import { error, json } from "@sveltejs/kit";
import { p as prisma } from "../../../../../chunks/prisma.js";
const POST = async ({ locals: { user }, request }) => {
  if (!user) return error(401, "Unauthorized: No user logged in");
  try {
    const { planId } = await request.json();
    if (!planId) {
      return error(400, "Missing plan ID");
    }
    const plan = await prisma.subscriptionPlan.findUnique({
      where: { id: planId }
    });
    if (!plan) {
      return error(404, "Subscription plan not found");
    }
    const existingSubscription = await prisma.userSubscription.findFirst({
      where: {
        userId: user.id,
        status: "ACTIVE",
        isActive: true,
        endsAt: {
          gte: /* @__PURE__ */ new Date()
        }
      }
    });
    if (existingSubscription) {
      return error(400, "You already have an active subscription");
    }
    const now = /* @__PURE__ */ new Date();
    const endsAt = new Date(now.getTime() + plan.duration * 24 * 60 * 60 * 1e3);
    const subscription = await prisma.userSubscription.create({
      data: {
        userId: user.id,
        planId: plan.id,
        status: "ACTIVE",
        isActive: true,
        startsAt: now,
        endsAt
      }
    });
    return json({
      success: true,
      message: "Subscription activated successfully (Development Mode)",
      subscription: {
        id: subscription.id,
        planName: plan.name,
        endsAt: subscription.endsAt
      }
    });
  } catch (err) {
    console.error("Direct subscription error:", err);
    return error(500, "Failed to activate subscription");
  }
};
export {
  POST
};
